var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNavBranchBold = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62 6.18078C9.62 7.77136 10.9094 9.06078 12.5 9.06078C14.0906 9.06078 15.38 7.77136 15.38 6.18078C15.38 4.5902 14.0906 3.30078 12.5 3.30078C10.9094 3.30078 9.62 4.5902 9.62 6.18078Z",
    fill: "#F6932B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38 17.7008C3.38 19.2914 4.66942 20.5808 6.26 20.5808C7.85058 20.5808 9.14 19.2914 9.14 17.7008C9.14 16.1102 7.85058 14.8208 6.26 14.8208C4.66942 14.8208 3.38 16.1102 3.38 17.7008Z",
    fill: "#F6932B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.74 20.5808C17.1494 20.5808 15.86 19.2914 15.86 17.7008C15.86 16.1102 17.1494 14.8208 18.74 14.8208C20.3306 14.8208 21.62 16.1102 21.62 17.7008C21.62 19.2914 20.3306 20.5808 18.74 20.5808Z",
    fill: "#F6932B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89649 7.6806C8.19463 7.41746 8.223 6.96247 7.95986 6.66434C7.69673 6.3662 7.24174 6.33783 6.9436 6.60097C5.2009 8.1391 4.1 10.3918 4.1 12.9008C4.1 13.2985 4.42236 13.6208 4.82 13.6208C5.21765 13.6208 5.54 13.2985 5.54 12.9008C5.54 10.8221 6.45035 8.95697 7.89649 7.6806Z",
    fill: "#F6932B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0564 6.60097C17.7583 6.33783 17.3033 6.3662 17.0401 6.66434C16.777 6.96247 16.8054 7.41746 17.1035 7.6806C18.5497 8.95697 19.46 10.8221 19.46 12.9008C19.46 13.2985 19.7824 13.6208 20.18 13.6208C20.5776 13.6208 20.9 13.2985 20.9 12.9008C20.9 10.3918 19.7991 8.1391 18.0564 6.60097Z",
    fill: "#F6932B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7595 19.6416C10.3744 19.5425 9.98185 19.7743 9.88273 20.1594C9.78361 20.5445 10.0154 20.937 10.4005 21.0361C11.0723 21.209 11.776 21.3008 12.5 21.3008C13.224 21.3008 13.9277 21.209 14.5995 21.0361C14.9846 20.937 15.2164 20.5445 15.1173 20.1594C15.0182 19.7743 14.6256 19.5425 14.2405 19.6416C13.685 19.7846 13.1019 19.8608 12.5 19.8608C11.8981 19.8608 11.315 19.7846 10.7595 19.6416Z",
    fill: "#F6932B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavBranchBold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NavBranchBold.a8e67e0b.svg";
export { ForwardRef as ReactComponent };